module.exports = __webpack_public_path__ + "img/services-icon-3.fa103028.png";